import { useAppScope } from '@/modules/app-scope/context/use-app-scope';
import { useCallback, useMemo, useState } from 'react';
import { useAnalytics } from 'use-analytics';
import { useCaApiSdk } from '../../api-sdk/context/use-ca-api-sdk';
import { CaUserContext } from './ca-user-context';
import { CaUser } from './types';

export const CaUserProvider: React.FC<React.PropsWithChildren> = (props) => {
  const [user, setUser] = useState<CaUser>(null);

  const { appScope } = useAppScope();
  const { identify } = useAnalytics();
  const sdk = useCaApiSdk();

  const clearUser = useCallback(() => {
    setUser(null);
  }, [setUser]);

  const { isLoading } = sdk.useMe(
    'Me',
    {},
    {
      onSuccess: (response) => {
        if (response?.viewer?.me) {
          setUser(response.viewer.me);

          void identify(response.viewer.me.id, {
            $email: response.viewer.me.email, // mixpanel default email
            $name: `${response.viewer.me.firstName || ''} ${response.viewer.me.lastName || ''}`, // mixpanel default name
            ...response.viewer.me,
            appScope,
          });
        }
      },
    },
  );

  const memoizedValue = useMemo(() => {
    return { user, clearUser, isLoading };
  }, [user, clearUser, isLoading]);

  return <CaUserContext.Provider {...props} value={memoizedValue} />;
};
